import React from 'react';
import Form from "react-bootstrap/Form";
import {Button} from "react-bootstrap";

function ExpirationPicker(props) {

    const expPicklist = props.options || ["NONE", "1", "2", "4", "12", "24"];

    return (
        <Form.Group className="mb-3">
            <Form.Label>Expiration In Hours</Form.Label>
            <div className="d-flex">
                {(expPicklist.map((exp, idx) => (
                    <Button
                        key={exp}
                        variant={String(props.expiresIn) === String(exp) ? "primary" : "outline-primary"}
                        active={String(props.expiresIn) === String(exp)}
                        onClick={() => props.setExpiresIn(exp)}
                        className={idx !== (expPicklist.length - 1) ? "w-100 border-end-0 rounded-0" : "w-100 rounded-0"}
                        style={{
                            borderRadius: idx === 0
                                ? "0.375rem 0 0 0.375rem"
                                : idx === expPicklist.length - 1
                                    ? "0 0.375rem 0.375rem 0"
                                    : "0"
                        }}
                    >
                        {exp}
                    </Button>
                )))}
            </div>
        </Form.Group>
    );
}

export default ExpirationPicker;
